import React from "react";

export const TabPanel = (props: any) => {
    const {children, value, index, preserveTab, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}>
            {(preserveTab || value === index) && children}
        </div>
    );
}
